import React, { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { ListDropdownMultipleProps } from "../../model/user";
import LocalStorageService from "../../services/localStorage";
import { useUserGetAll } from "../../fnx/user/userGetAll";

import {
  DrawerProps,
  typeAlert,
} from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import showToast from "../../services/toast";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
import { UserView } from "./ui/viewV2";
import { UserInterface } from "./types/types";
import { useCreateUserForm } from "./hooks/useCreateUser";

import { Users } from "@affinitysystemsgroup/github-packages-affinity-components/dist/src/dto/users";
import {
  SelectOption,
  UserCardProps,
} from "@affinitysystemsgroup/github-packages-affinity-components/dist/src/pages/UsersPage/type/UsersPage.type";
import logoAffinity from "../../assets/images/logoAffinity.svg";

import {
  paginationAFYProps,
  searchFiltersBarProps,
  userCardAddNewProps,
  cardContextMenuAFYProps,
  createUserProps,
  drawerProps,
  stepsProps,
  viewTypeAfyProps,
  drawerRolesListProps,
  drawerRolesEditProps,
} from "./data";
import { CUserModel } from "./types/types";
import { useRoleUser } from "./hooks/useRoleUser";
import { useFilters } from "./hooks/useFilters";
import { useClickMenu } from "./hooks/useClickMenu";
import { useInputSearch } from "./hooks/useInputSearch";
import { DrawerDragAndDropProps } from "@affinitysystemsgroup/github-packages-affinity-components/dist/src/pages/UsersPage/components/DrawerDragAndDrop";
import { DrawerRolesListProps } from "@affinitysystemsgroup/github-packages-affinity-components/dist/src/pages/UsersPage/components/drawerRolesList";
import { useDeleteUser } from "./hooks/useDeleteUser";
import { ModalDelete } from "../user/resources/modalDelete";
const storageKey2 = "afy-login";
const lsLogin = new LocalStorageService(storageKey2);

export const UserAdminV2 = () => {
  const dispatch = useDispatch();
  const [list, setList] = useState<CUserModel[]>([]);
  const [loadingPage, setLoadingPage] = useState<boolean>(false);
  const [loadingMessage, setLoadingMessage] = useState<string>("");
  const [trigger, setTrigger] = useState(true);
  const [clientId] = React.useState<string>(
    lsLogin.getUserLoginStored().clientId
  );
  const [branchId] = React.useState<string>(
    lsLogin.getUserLoginStored().branchId
  );
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(20);

  const [seeToast, setSeeToast] = useState<{
    show: boolean;
    type: typeAlert;
    message: string;
  }>({
    show: false,
    message: "",
    type: typeAlert.success,
  });

  //custom hooks
  const useCreateForms = useCreateUserForm(setSeeToast);
  const useRoleUsers = useRoleUser(setSeeToast, setTrigger);
  const useFiltersUsers = useFilters();
  const useClickMenus = useClickMenu();
  const useDeleteUsers = useDeleteUser();
  
  const handleSearchChange = useCallback((value: string) => {
    setTrigger(true);
  }, []);

  const useInputSearchHook = useInputSearch(handleSearchChange);

  // Pagination handlers
  const handleChangePage = useCallback((newPage: number) => {
    setPage(newPage);
    setTrigger(true);
  }, []);

  const handleChangeRowsPerPage = useCallback((newLimit: number) => {
    setLimit(newLimit);
    setPage(1); // Reset to first page when changing rows per page
    setTrigger(true);
  }, []);

  const { responseUser, errorUser, loadingUser, pagingInfo } = useUserGetAll(
    trigger,
    '',
    page,
    limit,
    useInputSearchHook.debouncedValue
  );

  useEffect(() => {
    if (responseUser) {
      const list: CUserModel[] = responseUser.map((item: UserInterface) => ({
        ...item,
        status: item.enabled ? "Activo" : "Inactivo",
      }));
      setList(list);
      setPage(pagingInfo.page);
      setLimit(pagingInfo.limit);
    }
    setTrigger(false);
  }, [responseUser, pagingInfo]);

  const handleEditUser = (user: CUserModel) => {
    console.log("user", user);
    const userInterface: UserInterface = {
      id: user.id || "",
      name: user.name || "",
      lastName: user.lastName || "",
      email: user.email || "",
      userName: user.userName || "",
      avatarUrl: user.avatarUrl || "",
      enabled: user.enabled || false,
      branchId: user.branchId || "",
      clientId: user.clientId || "",
      createdAt: "",
      deleted: false,
      disabledReason: "",
      lastLoginAt: "",
      loginAttempts: 0,
      roles: [],
    };
    useCreateForms.setSelectedUser(userInterface);
    useCreateForms.setOpenDrawer(true);
  };

  const drawerRolesListProps: DrawerProps & DrawerRolesListProps = {
    openDrawer: useRoleUsers.openDrawerRoles,
    view: 1,
    BgBackdrop: "transparent",
    BgcCloseButton: "#fff",
    colorIcon: "#000",
    bgColorDrawer: "#fff",
    customHeight: "40vh",
    img: logoAffinity,
    title: "Permisos",
    text: "",
    onValueApply: () => {},
    onClose: () => {
      useRoleUsers.setOpenDrawerRoles(false);
    },
    paginationProps: {
      count: 10,
      pagePagination: 1,
      rowsPerPages: 10,
      onChangePage: () => {},
      onChangeRowsPerPage: () => {},
      rowsPerPageOptions: [5, 10, 25],
    },
    onClickEdit: () => {
      useRoleUsers.setOpenDrawerRoles(false);
      useRoleUsers.setOpenDrawerRolesEdit(true);
    },
    data: useRoleUsers.rolsSelected,
    columns: [
      {
        field: "name",
        headerName: "Nombre",
      },
      {
        field: "description",
        headerName: "Descripcion",
      },
    ],
  };

  const drawerRolesEditProps: DrawerDragAndDropProps = {
    open: useRoleUsers.openDrawerRolesEdit,
    onClose: () => {
      useRoleUsers.setOpenDrawerRolesEdit(false);
    },
    onRoleMove: useRoleUsers.onRoleMove,
    onRoleDelete: useRoleUsers.onRoleDelete,
    availableItems: useRoleUsers.availableItems,
    assignedItems: useRoleUsers.assignedItems,
    onSave: useRoleUsers.onSaveRolPermissions,
    title: `Asignar rol: ${useRoleUsers.selectedUser?.name}`,
    subtitle:
      "Arrastra los roles disponibles hacia el cuadrante de Roles Asignados para asignar uno",
    availableTitle: "Roles Disponibles",
    assignedTitle: "Roles Asignados",
    availablePlaceholder: "Buscar Rol",
    assignedPlaceholder: "Buscar Rol",
    availableSearch: useRoleUsers.availableSearch,
    assignedSearch: useRoleUsers.assignedSearch,
    onAvailableSearchChange: useRoleUsers.onAvailableSearchChange,
    onAssignedSearchChange: useRoleUsers.onAssignedSearchChange,
    filteredAvailable: useRoleUsers.availableItemsFiltered,
    filteredAssigned: useRoleUsers.assignedItemsFiltered,
    textCancelButton: "Cancelar",
    textSaveButton: "Asignar Roles",
  };

  const dataUsers: Users = {
    viewTypeAfyProps,
    paginationAFYProps: {
      ...paginationAFYProps,
      countPagination: pagingInfo?.totalItems || 0,
      pagePagination: page,
      rowsPerPage: limit,
      onChangePage: handleChangePage,
      onChangeRowsPerPage: handleChangeRowsPerPage,
    },
    drawerRolesListProps,
    drawerRolesEditProps,
    searchFiltersBarProps: {
      ...searchFiltersBarProps,
      term: useInputSearchHook.searchValue,
      showSearch: useFiltersUsers.showSearch,
      setShowSearch: useFiltersUsers.handleShowSearch,
      closeSearch: useFiltersUsers.handleShowSearch,
      clearFilter: useFiltersUsers.clearFilters,
      inputSearchConfig: useInputSearchHook.inputSearchConfig,
      filters: [
        {
          id: "rol",
          label: "Rol",
          list: useRoleUsers.rolList as ListDropdownMultipleProps[],
          defaultCheckedItems: useFiltersUsers.defaultCheckedItemsRol,
          onSelect: useFiltersUsers.handleRolFilter,
        },
        {
          id: "branch",
          label: "Sucursal",
          list: useCreateForms.branchOptions as unknown as ListDropdownMultipleProps[],
          defaultCheckedItems: useFiltersUsers.defaultCheckedItemsBranch,
          onSelect: useFiltersUsers.handleBranchFilter,
        },
        {
          id: "status",
          label: "Estado",
          list: [
            {
              id: "true",
              name: "Activo",
              value: "true",
            },
            {
              id: "false",
              name: "Inactivo",
              value: "false",
            },
          ],
          defaultCheckedItems: useFiltersUsers.defaultCheckedItemsActive,
          onSelect: useFiltersUsers.handleActiveFilter,
        },
      ],
    },
    userCardAddNewProps: {
      ...userCardAddNewProps,
      onClickAdd: () => useCreateForms.setOpenDrawer(true),
    },
    cardContextMenuAFYProps: {
      ...cardContextMenuAFYProps,
      onClickContextMenu: (menuItem, options) => {
        console.log("menuItem", menuItem);
        switch (menuItem.id) {
          case "1":
            const selectedUser = list.find((user) => user.id === options.id);
            console.log("selectedUser", selectedUser);
            if (selectedUser) {
              handleEditUser(selectedUser);
            }
            break;
          case "2":
            console.log("options 2", options);
            useDeleteUsers.setOpenModalDelete(true);
            useDeleteUsers.setModalTitle(
              "¿Estás seguro de querer eliminar este usuario?"
            );
            break;
          case "4":
            console.log("options 4", options);
            useRoleUsers.setOpenDrawerRoles(true);
            useRoleUsers.setSelectedUser(options);
            break;
        }
        // useClickMenus.handleClickMenu(menuItem, options);
      },
    },
    createUserProps: {
      ...createUserProps,
      onSubmit: useCreateForms.onSubmit,
      idTypeOptions: useCreateForms.idTypeOptions as SelectOption[],
      genderOptions: useCreateForms.genderOptions as SelectOption[],
      companyOptions: useCreateForms.companyOptions as SelectOption[],
      branchOptions: useCreateForms.branchOptions as SelectOption[],
      intermediaryOptions: useCreateForms.intermediaryOptions as SelectOption[],
      formCreateUser: useCreateForms.formCreateUser,
    },
    drawerProps: {
      ...drawerProps,
      openDrawer: useCreateForms.openDrawer,
      onClose: () => {
        useCreateForms.setOpenDrawer(false);
        useCreateForms.setSelectedUser(null);
      },
      title: useCreateForms.isEditing ? "Editar usuario" : "Crear usuario",
      subTitle: useCreateForms.isEditing
        ? "Edita la información del usuario"
        : "Crea un nuevo usuario para tu sistema",
      titleButton: useCreateForms.isEditing ? "Actualizar" : "Crear",
      onValueApply: useCreateForms.onSubmit,
    },
    stepsProps,
    data: list as UserCardProps[],
    showPagination: true,
    columnsTable: [
      {
        field: "name",
        headerName: "Nombre",
        width: 150,
      },
      {
        field: "lastName",
        headerName: "Apellido",
        width: 150,
      },
      {
        field: "email",
        headerName: "Email",
        width: 150,
      },
      {
        field: "status",
        headerName: "Estado",
        width: 150,
      },
    ],
  };

  return (
    <React.Fragment>
      <ModalDelete
        openModalConfirmDelete={useDeleteUsers.openModalDelete}
        setOpenModalDelete={useDeleteUsers.setOpenModalDelete}
        modalTitle={"¿Estás seguro de querer eliminar este usuario?"}
        onClickDelete={useDeleteUsers.onSubmit}
      />
      <AlertLoadingHeader
        loading={
          loadingPage ||
          loadingUser ||
          useCreateForms.loadingCreateUser ||
          useRoleUsers.loadingSaveRolPermissions
        }
        seeToast={seeToast}
        showToast={showToast}
        setSeeToast={setSeeToast}
        titleLoading={loadingMessage}
      />
      <UserView {...dataUsers} />
    </React.Fragment>
  );
};
